module.exports = __webpack_public_path__ + "media/images/welcome3-60e66d0696ccc91995b25b07b1f031c0.jpg";